<app-loading-overlay [isLoading]="tournServ.loadingPlayerMoves" class="dialog-fill">
  <bv-dialog-title>
    @if (isBreaking) {
      <span>{{ "BREAKING_TABLE" | translate }}</span>
    }
    @if (!isBreaking) {
      <span>{{
        "MANUAL_SEAT_CHANGE" | translate
      }}</span>
    }
  </bv-dialog-title>
  <bv-dialog-body class="player-moves-content">
    @if (isBreaking && tournServ.tableBreaking) {
      <div class="flex flex-row items-center justify-center gap-4 py-2">
        <img src="/assets/img/badge-break-table.png" class="w-24 sm:w-60 h-auto" />
        <div class="flex flex-col items-center justify-center">
          <div class="text-sm sm:text-base text-gray-400">{{ "TABLE" | translate }}</div>
          <div class="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold text-bv-orange">
            {{ tournServ.tableBreaking }}
          </div>
        </div>
      </div>
    }
    @if (
      tournServ.playerMoves &&
      tournServ.playerMoves.length > 0 &&
      tournServ.playerMoves[0].unableToBalance
      ) {
      <div
        class="text-center py-8"
        >
        <bv-icon class="text-4xl text-gray-400" name="lock"></bv-icon>
        <h2 class="text-xl font-medium text-gray-400 mt-4">
          {{ "UNABLE_TO_BALANCE_TABLES" | translate }}
        </h2>
      </div>
    }

    <!-- Desktop table layout (hidden on mobile) -->
    @if (
      !tournServ.playerMoves ||
      tournServ.playerMoves.length === 0 ||
      !tournServ.playerMoves[0].unableToBalance
      ) {
      <table
        class="w-full hidden sm:table"
        >
        <th></th>
        <th></th>
        @if (!isBreaking) {
          <th class="text-bvdarkblue-A300">
            {{ "TABLE" | translate }}
          </th>
        }
        <th class="text-bvdarkblue-A300">{{ "SEAT" | translate }}</th>
        <th></th>
        <th>{{ "TABLE" | translate }}</th>
        <th>{{ "SEAT" | translate }}</th>
        @for (move of tournServ.playerMoves; track $index) {
          <tr>
            <td><img class="h-10 w-10 rounded-full" src="{{ move.imgURL }}" /></td>
            <td>
              <h2>{{ move.dispName }}</h2>
            </td>
            @if (!isBreaking) {
              <td class="text-bvdarkblue-A300 text-center">
                {{ move.from.table }}
              </td>
            }
            <td class="text-bvdarkblue-A300 text-center">{{ move.from.seat }}</td>
            <td class="text-center">
              <bv-icon name="arrow_forward" class="tc-bv-orange"></bv-icon>
            </td>
            <td class="text-xl font-medium text-center">{{ move.to.table }}</td>
            <td class="text-xl font-medium text-center">{{ move.to.seat }}</td>
          </tr>
        }
      </table>
    }

    <!-- Mobile card layout (hidden on desktop) -->
    @if (
      !tournServ.playerMoves ||
      tournServ.playerMoves.length === 0 ||
      !tournServ.playerMoves[0].unableToBalance
      ) {
      <div
        class="block sm:hidden"
        >
        @for (move of tournServ.playerMoves; track $index) {
          <div
            class="flex flex-row items-center py-2 border-b border-gray-700"
            >
            <img class="h-10 w-10 rounded-full mr-3 flex-shrink-0" src="{{ move.imgURL }}" />
            <div class="flex-1 min-w-0">
              <div class="font-medium text-base truncate">{{ move.dispName }}</div>
              <div class="flex flex-row items-center text-sm mt-1">
                @if (!isBreaking) {
                  <span class="text-bvdarkblue-A300">T{{ move.from.table }}/</span>
                }
                <span class="text-bvdarkblue-A300">S{{ move.from.seat }}</span>
                <bv-icon class="mx-1 tc-bv-orange" style="font-size: 18px; width: 18px; height: 18px;" name="arrow_forward"></bv-icon>
                <span class="font-bold">T{{ move.to.table }}/S{{ move.to.seat }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </bv-dialog-body>

  <bv-dialog-footer>
    <app-close-dialog-button></app-close-dialog-button>
  </bv-dialog-footer>
</app-loading-overlay>
